module.exports = __webpack_public_path__ + "static/media/Circo2024_02.02034b09.webp";